import clsx from "clsx";
import { TextProps } from "./PropsTypes";

export default function TextVerify({ children, className }: TextProps) {
	return <p className={clsx("verify-text mt-2.5", className)}>{children}</p>;
}
